import { takeLatest } from "redux-saga/effects";
import {
  fetchAppMeta,
  fetchAppMetaStart,
  fetchAppMetaSuccess,
  fetchAppMetaFailure,
} from "@/store/slices/appMeta";
import { fetcherForSagas } from "@/store/fetcherForSagas";
import { requestAppMeta } from "@/common/api/requests";

function* app_meta() {
  yield takeLatest(
    fetchAppMeta,
    fetcherForSagas({
      start: fetchAppMetaStart,
      success: ({ data, ...other }: any) => fetchAppMetaSuccess({ data, ...other }),
      failure: fetchAppMetaFailure,
      request: () => requestAppMeta(),
    })
  );
}

export default app_meta;
